import {pageInfo} from '../api';
import {plant} from '../../../../api'
import {Message} from 'element-ui';

const hikVehicleRelease = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: null,
    supplierObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [true]}));
    },
    PLANT(state, data) {
      state.plantObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
  }
}
export default hikVehicleRelease



// WEBPACK FOOTER //
// ./src/page/int/hikVehicleRelease/store/hikVehicleRelease.store.js